import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AuthBrandPanelComponent } from '../auth-brand-panel/auth-brand-panel.component';

/**
 * Casca das telas de autenticação: painel de marca à esquerda + área do formulário à direita
 * (barra superior com ajuda, conteúdo centralizado com largura máxima de 400px e rodapé
 * compacto no mobile). O conteúdo da página entra por ng-content.
 */
@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [MatIconModule, AuthBrandPanelComponent],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.css',
})
export class AuthLayoutComponent {}
